<template>
  <div class="cargo-preview-wrapper">
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :fullscreen="true"
      :show-close="false"
      :close-on-click-modal="false"
      append-to-body
      class="cargo-template-preview-full-dialog"
    >
      <template slot="title">
        <div style="padding-top: 15px;">
          <el-button type="primary" no="1" @click="onReturnMain">{{ $t('Viewer.backToMain') }}</el-button>
          <el-button type="primary" no="2" @click="printTemplateEvent('btnPrint')">{{ $t('Viewer.print') }}</el-button>
          <el-button type="primary" no="3" @click="printTemplateEvent('btnSavePdf')">{{ $t('Viewer.savePDF') }}</el-button>
          <el-button type="primary" no="4" @click="printTemplateEvent('btnSaveWord')">{{ $t('Viewer.saveWord') }}</el-button>
          <el-button type="primary" no="5" @click="printTemplateEvent('btnSaveExcel')">{{ $t('Viewer.saveExcel') }}</el-button>
          <el-button type="primary" no="6" @click="emailClickHandler">{{ $t('Viewer.email') }}</el-button>
        </div>
      </template>
      <div class="cargoTemplatePreview">
        <div class="pdf">
          <pdf v-for="i in numPages" :key="i" :src="pdfSrc" :page="i" />
        </div>
      </div>
    </el-dialog>

    <!-- 发送邮件弹窗 -->
    <email-input-dialog v-show="emailInputDialog.visible" :visible.sync="emailInputDialog.visible" :context="context" :job-model="entity" source="cargoTemplatePreview" :send-email-data="emailInputDialog" :job-uuid-list="jobUuidList" :send-call-back="onEmailExecute" />
  </div>
</template>

<script>
import pdf from 'vue-pdf'
import URL from '@/api/urlTranslator'
import { getToken } from '@/utils/auth' // get token from cookie
import { PrintUtils } from '@/utils/PrintUtils'
import { PrintTemplateManager } from '@/class/cargo/model/utils/PrintTemplateManager'
import { saveTemplateAccess } from '@/api/sysManage/baseConfig/template'
import emailInputDialog from '@/components/Cargo/Job/emailInputDialog'

export default {
  name: 'CargoTemplatePreview',
  components: { pdf, emailInputDialog },
  props: {
    visible: { type: Boolean, required: true },
    entity: { type: Object, default: null }, // 相当于老系统的 entity
    parameters: { type: Object, required: true },
    template: { type: Object, default: null },
    context: { type: Object, required: true },
    fetchSize: { type: Number, default: 0 },
    jobUuidList: { type: Array, default: null }
  },
  data() {
    return {
      innerVisible: false,
      numPages: '',
      pdfSrc: '',
      emailInputDialog: {
        visible: false,
        emailTitle: '',
        emailContent: '',
        detailCode: '',
        fileIdList: ''
      },
      printParam: null // 记录点击打印，导出Excel等操作的相关信息，点击返回主页面的时候返回出去
    }
  },
  watch: {
    visible: {
      immediate: true,
      async handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          await this.showPreview()
        }
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.pdfSrc = ''
        this.printParam = null
      }
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    async showPreview() {
      const url = `${URL.report.templatePreview}` + '?template=' + this.template.templateFile + '&format=SWF&printType=PRINT&sessionId=' + encodeURIComponent(getToken()) + '&' + PrintTemplateManager.toUrlArgs(this.parameters)
      this.pdfSrc = pdf.createLoadingTask(encodeURI(url))
      await this.pdfSrc.promise.then(pdf => {
        this.numPages = pdf.numPages
        this.addTemplateAccess()
      }).catch((err) => {
        console.log('获取模板失败', err)
      })
    },
    /**
     * 模板访问日志
     */
    async addTemplateAccess() {
      const template = this.template
      if (template == null) return
      const templateAccess = {}
      templateAccess.templateId = template.templateId
      templateAccess.name = template.name
      templateAccess.templateType = template.templateType
      templateAccess.officeId = this.$store.getters.currentOfficeId
      templateAccess.templateFile = template.templateFile
      templateAccess.remarks = '打印模板：' + template.name
      templateAccess.docId = ''
      templateAccess.docType = ''
      await saveTemplateAccess(templateAccess).then(res => {})
    },
    onReturnMain() {
      this.$emit('returnMainEvent', this.printParam)
      this.innerVisible = false
    },
    /**
     * 保存打印文件
     */
    printTemplateEvent(type) {
      this.parameters.printType = PrintTemplateManager.PRINT
      switch (type) {
        case 'btnPrint':
        {
          this.saveTemplateFile(PrintUtils.PRINT, PrintTemplateManager.FORMAT_PDF)
          // this.$emit('updateDocCfmStateFunc')
          this.sopTrigger(type)
          break
        }
        case 'btnSavePdf':
        {
          this.saveTemplateFile(PrintUtils.SAVE, PrintTemplateManager.FORMAT_PDF)
          this.sopTrigger(type)
          break
        }
        case 'btnSaveWord':
        {
          this.saveTemplateFile(PrintUtils.SAVE, PrintTemplateManager.FORMAT_RTF)
          this.sopTrigger(type)
          break
        }
        case 'btnSaveExcel':
        {
          this.saveTemplateFile(PrintUtils.SAVE, PrintTemplateManager.FORMAT_XLSX)
          this.sopTrigger(type)
          break
        }
      }
    },
    /**
     * @private
     */
    saveTemplateFile(action, format) {
      const obj = {}
      obj.action = action
      obj.format = format
      this.printParam = obj
      this.$emit('printTempFileEvent', obj)
    },
    /**
     * sop触发
     */
    sopTrigger(type) {
      this.$emit('sopTriggerEvent', type)
    },
    /**
     * @protected
     * 邮件
     */
    emailClickHandler(event) {
      if (!this.entity) return
      this.emailInputDialog.visible = true
    },
    /**
     * @private
     * 返回方法
     */
    onEmailExecute(title, address, emailCc, content, mailType) {
      this.parameters.officeId = this.$store.getters.currentOfficeId
      this.parameters.mailType = mailType
      this.parameters.mailContent = content
      this.parameters.pushLink = '4'
      this.parameters.emailCc = emailCc
      this.parameters.printType = PrintTemplateManager.EMAIL
      this.parameters.title = title
      this.parameters.address = address
      this.parameters.content = content
      if (Object.prototype.hasOwnProperty.call(this.parameters, 'fileAliasName') && !this.parameters.fileAliasName) {
        this.saveTemplateFile(PrintUtils.EMAIL, PrintTemplateManager.FORMAT_PDF)
      } else {
        this.saveSendEmailFile()
      }
      this.emailInputDialog.visible = false
    },
    /**
     * @private
     */
    saveSendEmailFile() {
      this.$emit('sendEmailTriggerEvent', '')
    }
  }
}
</script>

<style lang="less">
  .cargo-template-preview-full-dialog {
    .el-dialog {
      display: flex;
      flex-direction: column;
      .el-dialog__body {
        overflow-y: auto;
      }
    }
  }
  .cargoTemplatePreview {
    height: auto;
    .pdf {
      // height: 800px;
      overflow: auto;
      // border: 1px solid #ccc;
      padding: 20px;
      width: 960px;
      margin: 0 auto;
      box-shadow: 0 0 12px #ccc;

      canvas {
        width: 940px !important;
      }

      .annotationLayer {
        width: 940px !important;
      }
    }
  }
</style>
